import {
  AutoComplete,
  Avatar,
  Button,
  Form,
  Input,
  Modal,
  Select,
  Spin,
  DatePicker,
  Drawer,
} from "antd";

import React, {
  ReactElement,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";

import axios from "axios";
import { authenticateToken } from "../../../utils/auth";
import {
  getPage,
  getParamValue,
  checkStatesAndPushToHistory,
} from "../../../utils/index";
import Loading from "../../common/Loader";
import PaginationTwo from "../../common/PaginationTwo";
import { useLocation, useParams, useHistory } from "react-router";
import Empty from "../../common/Empty";
import { responseNotification } from "../../../utils/notify";
import { debounce } from "lodash";
import { PlusOutlined } from "@ant-design/icons";
import ShopLayout from "../Layout";
import ShopHeader from "../Layout/topHeader";
import { useSelector } from "react-redux";
import usePrevious from "../../../hooks/PreviousState";
import moment from "moment";
import CampaignDetails from "../Campaigns/CampaignDetails";
const { RangePicker } = DatePicker;

const ShopCampaignList = (params): ReactElement => {
  const router = useLocation();
  const [range, setRange] = useState({
    from: getParamValue(router.search, "from")
      ? getParamValue(router.search, "from")
      : null,
    to: getParamValue(router.search, "to")
      ? getParamValue(router.search, "to")
      : null,
  });
  const from = moment(range.from)?.toISOString();
  const to = moment(range.to)?.toISOString();
  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const [visible, setVisible] = useState(undefined);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(undefined);
  const showModal = () => {
    setIsModalVisible(true);
  };
  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setVisible(undefined);
    setIsModalVisible(false);
  };
  const [campaignOptions, setCampaignOptions] = useState({
    loading: false,
    list: null,
  });
  const [campaignData, setCampaignData] = useState({
    loading: false,
    data: null,
  });
  const history = useHistory();
  // --------------------------------
  const { shopInfo } = useSelector((state) => (state as any)?.authReducer);
  const shopId = shopInfo?.id;
  const route = useParams();

  // --------------------------------
  const [limit, setLimit] = useState(50);
  const [key, setKey] = useState(getParamValue(router?.search, "key"));
  const [campaignId, setCampaignId] = useState<any>();
  // **********************************
  // Search Options
  // **********************************
  const reseAllFieldData = () => {
    setKey("");
    form.resetFields();
    history.replace(router.pathname);
    window.location.reload();
  };

  const getCampaignOptions = useCallback(async (key) => {
    setCampaignOptions({ loading: true, list: null });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    axios
      .get(
        `${encodedUri}/campaign-shop/by-shop?shopId=${shopId}` +
          (key ? `&key=${key}` : ``) +
          `&page=${page || 0}` +
          `&limit=${limit || 16}`,
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setCampaignOptions({
          loading: false,
          list: res.data?.campaigns?.map((campaign: any) => ({
            label: campaign.name,
            value: campaign.id,
          })),
        });
      })
      .catch((err) => {
        setCampaignOptions({ loading: false, list: [] });
        console.error("Categories: Error", err);
      });
  }, []);

  const fetchRef = useRef(0);
  const campaignSearchDebounce = React.useMemo(() => {
    const loadOptions = (value: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      getCampaignOptions(value);
    };

    return debounce(loadOptions, 800);
  }, [getCampaignOptions]);

  const getCampaign = useCallback(async () => {
    let pageReseted = false;
    if (localStorage.getItem("rememberCampaignList") != null) {
      checkLocalStorageAndSetParams();
      localStorage.removeItem("rememberCampaignList");
    } else {
      pageReseted = checkStatesAndPushToHistory(
        [previousKey],
        [key],
        ["key"],
        history
      );
    }
    setCampaignData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    axios
      .get(
        `${encodedUri}/campaign-shop/by-shop?shopId=${shopId}` +
          (page ? `&page=${pageReseted ? 0 : page || 0}` : ``) +
          (limit ? `&limit=${limit}` : ``) +
          (key ? `&key=${key}` : ``),
        // (status ? `&status=${status}` : ``),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        setCampaignData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setCampaignData({ loading: false, data: [] });
        console.error("Campaign: Error", err);
      });
  }, [limit, page, key]);

  useEffect(() => {
    getCampaign();
  }, [getCampaign]);

  const previousKey = usePrevious(key);
  function checkLocalStorageAndSetParams() {
    var retrievedObject = JSON.parse(
      localStorage.getItem("rememberCampaignList")
    );
    if (retrievedObject.key) setKey(retrievedObject.key);
  }
  const onSubmit = async (data: any) => {
    setLoading(true);
    const readyData = data && {
      campaigns: data.campaignId.map((campaign: any, index: string) => ({
        campaignId: campaign,
        displayOrder:
          index +
          1 +
          (campaignData?.data?.campaigns?.[
            campaignData?.data?.campaigns?.length - 1
          ]?.displayOrder * 1 || 0),
      })),
      shopId: shopInfo?.id,
    };
    await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/campaign-shop`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${authenticateToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(readyData),
    })
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);
        if (res.statusCode === 200) {
          responseNotification("Campaign Assigned Successfully", "success");
          form.resetFields();
          handleOk();
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        setLoading(false);
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };

  useEffect(() => {
    if (visible) {
      setSelectedCampaign(undefined);
    }
  }, [selectedCampaign]);

  useEffect(() => {
    setSelectedCampaign(undefined);
  }, [visible]);

  const onClose = () => {
    setSelectedCampaign(null);
    getCampaign();
  };
  return (
    <React.Fragment>
      <ShopLayout shopId={shopId}>
        <>
          <section className="product-lists">
            <div className="product-list-item-area white-bg">
              <ShopHeader
                leftarea={"Campaign List"}
                rightarea={
                  <div className="">
                    {/* <Button
                      danger
                      type="primary"
                      icon={<PlusOutlined />}
                      title="Add Campaign"
                      onClick={showModal}
                    >
                      Add Campaign
                    </Button> */}
                  </div>
                }
              />

              <section className="search_area">
                <Form form={form} className="search_form">
                  <Form.Item name="search" initialValue={key}>
                    <AutoComplete
                      onSearch={getCampaignOptions}
                      onSelect={(val) => setKey(val.toString())}
                      options={campaignOptions?.list}
                      defaultActiveFirstOption={false}
                      notFoundContent={
                        campaignOptions?.loading ? <Spin size="small" /> : null
                      }
                      style={{ width: 300 }}
                    >
                      <Input.Search
                        size="large"
                        placeholder="Search by Name"
                        onSearch={(val) => setKey(val)}
                        enterButton
                        loading={campaignOptions.loading}
                        maxLength={11}
                      />
                    </AutoComplete>
                  </Form.Item>
                </Form>
                <div className="search_btn">
                  <Button
                    type="primary"
                    danger
                    size="large"
                    onClick={reseAllFieldData}
                  >
                    Reset
                  </Button>
                </div>
              </section>
              <div className="product-list-item-area white-bg section-padding-bottom">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="product-list-items-inner-content">
                        <div className="single-product-wrapper">
                          <div className="single-product-heading">
                            <span>Campaign Name</span>
                          </div>
                          <div className="single-product-heading">
                            <span>Start Date</span>
                          </div>
                          <div className="single-product-heading">
                            <span>End Date</span>
                          </div>
                          <div className="single-product-heading">
                            <span>Type</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {campaignData?.loading ? (
                      <Loading />
                    ) : (
                      <div className="col-lg-12 product-table">
                        <div className="product-table-area">
                          {campaignData?.data?.campaigns?.length ? (
                            campaignData?.data?.campaigns?.map(
                              (campaign: any, index: any) => (
                                <React.Fragment key={index}>
                                  {/* <Link to={`/users/${user?.id}`}> */}
                                  <div
                                    className="single-product-wrapper"
                                    onClick={() =>
                                      setSelectedCampaign(campaign)
                                    }
                                  >
                                    <div className="single-product">
                                      <Avatar
                                        shape="square"
                                        size={45}
                                        src={campaign?.banner}
                                        className="mr-3"
                                      />
                                      <span className="name">
                                        {campaign?.name}
                                      </span>
                                    </div>
                                    <div className="single-product">
                                      <span className="name text-nowrap_">
                                        {moment(campaign?.startAt).format(
                                          "lll"
                                        )}
                                      </span>
                                    </div>
                                    <div className="single-product">
                                      <span className="name text-nowrap_">
                                        {moment(campaign?.endAt).format("lll")}
                                      </span>
                                    </div>
                                    <div className="single-product">
                                      <span className="name">
                                        {campaign?.type?.split("_").join(" ")}
                                      </span>
                                    </div>
                                  </div>
                                  {/* </Link> */}
                                </React.Fragment>
                              )
                            )
                          ) : (
                            <Empty data="campaigns" />
                          )}
                        </div>
                      </div>
                    )}

                    <Modal
                      title="Assign Campaign"
                      visible={isModalVisible}
                      onOk={handleOk}
                      onCancel={handleCancel}
                      footer={null}
                    >
                      <Form
                        name="control-hooks"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        className="ant-form ant-form-vertical"
                        onFinish={onSubmit}
                        form={form} // like ref
                        layout="vertical"
                        autoComplete="off"
                        initialValues={{
                          ...campaignData,
                        }}
                      >
                        <Form.Item
                          hasFeedback
                          label="Select Campaign"
                          name="campaignId"
                          rules={[
                            {
                              required: true,
                              message: "Pleasse Select Minimum One Campaign!",
                            },
                          ]}
                        >
                          <Select
                            disabled={!campaignData?.data ? true : false}
                            allowClear
                            showSearch
                            placeholder="Search Campaign"
                            optionFilterProp="children"
                            onChange={(val) => setCampaignId(val)}
                            onSearch={campaignSearchDebounce}
                            filterOption={() => {
                              return true;
                            }}
                            mode="multiple"
                            options={campaignOptions?.list}
                          ></Select>
                        </Form.Item>
                        <div className="buttons-container mt-3">
                          <Button
                            type="primary"
                            htmlType="submit"
                            className="add-submit-btn text-center mr-2"
                          >
                            Submit
                          </Button>
                          <Button
                            type="ghost"
                            htmlType="button"
                            onClick={() => form?.resetFields()}
                            className="reset-submit-btn text-center mr-2"
                          >
                            Reset
                          </Button>
                        </div>
                      </Form>
                    </Modal>
                  </div>

                  <Drawer
                    title={
                      setSelectedCampaign ? "Campaign Details" : "Edit Campaign"
                    }
                    width={500}
                    onClose={() => {
                      setSelectedCampaign(null);
                    }}
                    visible={selectedCampaign}
                    bodyStyle={{ paddingBottom: 80 }}
                    footer={
                      <div
                        style={{
                          textAlign: "right",
                        }}
                      ></div>
                    }
                  >
                    <CampaignDetails CampaignDetails={selectedCampaign} />
                  </Drawer>

                  <PaginationTwo
                    {...campaignData?.data}
                    limit={limit}
                    page={getPage(loc.search)}
                  />
                </div>
              </div>
            </div>
          </section>
        </>
      </ShopLayout>
    </React.Fragment>
  );
};

export default ShopCampaignList;
